import { FC } from 'react';
import FixedContainer from '@base/lib/FixedContainer';
import Image from '@base/lib/ThemeImage';
import site from 'pro/config/site';

export const FixedContact: FC = () => {
    return (
        <FixedContainer
            className={'pos-middle'}
            placement={['right', 'top']}
            offset={[30, '50%']}
            width={32}
            height={32}
        >
            <Image
                href={`tel:${site.contact.phone.url}`}
                width={32}
                src={'asset/width-128/picture/e32012f060f0778e520d7f533946a245.png'}
                background={false}
                fixed
            />
        </FixedContainer>
    )
};
